export const LOCALES = ['en', 'hr'];
export const LOCALE_LABELS = {
    en: 'English',
    hr: 'Hrvatski',
};
export function isLocale(v) {
    return v === 'en' || v === 'hr';
}
export function normalizeLocale(v, fallback = 'en') {
    if (typeof v === 'string') {
        const base = v.toLowerCase().split('-')[0];
        if (isLocale(base))
            return base;
    }
    return fallback;
}
//# sourceMappingURL=i18n.js.map